import { useTranslation } from "react-i18next";
import { Line } from "./ChartCanvas";
import {
    Chart as ChartJS,
    LineElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    Title,
    PointElement,
} from "chart.js";

ChartJS.register(
    LineElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    Title,
    PointElement
);

const SalesWaveChart = ({ data }) => {
    const { t } = useTranslation();
    const months = [
        t("January"),
        t("February"),
        t("March"),
        t("April"),
        t("May"),
        t("June"),
        t("July"),
        t("August"),
        t("September"),
        t("October"),
        t("November"),
        t("December")
    ];

    const branchSalesData = (data?.BRANCH_SALES || []).map((branch, index) => {
        const salesForBranch = months.map((month, monthIndex) => {
            const monthData = branch.BRANCH_SALES.find(
                (item) => item.MONTH === (monthIndex + 1)
            );
            return monthData ? monthData.SALES : 0;
        });

        return {
            label: branch.BRANCH_SALES[0]?.BRANCH_NAME || branch.BRANCH,
            data: salesForBranch,
            borderColor: `hsl(${(index * 60) % 360}, 100%, 40%)`,
            backgroundColor: `hsla(${(index * 60) % 360}, 80%, 40%)`,
            tension: 0.4,
            fill: true,
            pointRadius: 4,
            pointBackgroundColor: `hsl(${(index * 60) % 360}, 80%, 30%)`,
            pointBorderColor: "white",
            borderWidth: 2,
        };
    });

    const chartData = {
        labels: months,
        datasets: branchSalesData.length > 0 ? branchSalesData : [],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: "bottom",
                labels: {
                    usePointStyle: true,
                    padding: 20,
                },
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        return `المبيعات: ${tooltipItem.raw.toLocaleString()}`;
                    },
                },
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                titleFont: {
                    size: 18,
                },
                bodyFont: {
                    size: 16,
                },
                borderRadius: 50,
                padding: 10,
                boxPadding: 5,
                displayColors: true,
                labelColor: function (context) {
                    return {
                        borderColor: context.dataset.borderColor,
                        backgroundColor: context.dataset.borderColor,
                    };
                },
                custom: function (tooltip) {
                    tooltip.bodyFont = { size: 16 };

                    tooltip.body.forEach(function (bodyItem) {
                        bodyItem.before = `<span style="display: inline-block; width: 12px; height: 12px; border-radius: 50%; background-color: ${bodyItem.fillStyle}; margin-right: 5px; outline: none;"></span>`;
                    });
                },
            },
            title: {
                display: true,
                text: t("BRANCH_SALES_BY_MONTH"),
                align: "end",
                position: "top",
                font: {
                    size: 18,
                    weight: "500",
                    family: "'Cairo', SemiBold",
                },
                color: "#585858"

            },
        },
        scales: {
            x: {
                grid: {
                    display: false,
                }, ticks: {
                    autoSkip: false,
                    maxRotation: 0,
                    minRotation: 0,
                },
            },
            y: {
                ticks: {
                    callback: function (value) {
                        return value >= 1_000_000
                            ? `${value / 1_000_000}M`
                            : value.toLocaleString();
                    },
                    stepSize: 5_000_000,
                },
                grid: {
                    display: false,
                },
                border: {
                    display: false,
                },
            },
        },
    };

    return (
        <div className="Chart_Div">
            <Line data={chartData} options={options} />
        </div>
    );
};

export default SalesWaveChart;
